import { useMemoryRecordMarkdown } from '@apps/web/components/phoebe_chat_view/artifacts/record_preview/memory_record_preview';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@apps/web/components/ui/dialog';
import { Markdown } from '@apps/web/components/ui/markdown';
import { type NoteOutcomeEntity } from '@apps/web/lib/agent_note_outcome_copy';

/**
 * What Phoebe knows about one person, opened in place.
 *
 * The compiled document is long and sectioned, so the row shows only what
 * changed and this shows the whole record on demand — the same split the
 * playbook rows use.
 */
export function MemoryRecordModal({
    organizationId,
    entity,
    onClose,
}: {
    readonly organizationId: string;
    readonly entity: NoteOutcomeEntity;
    readonly onClose: () => void;
}) {
    const markdown = useMemoryRecordMarkdown(organizationId, entity);

    return (
        <Dialog
            open={true}
            onOpenChange={(next) => {
                if (!next) {
                    onClose();
                }
            }}
        >
            <DialogContent className="max-h-[80vh] overflow-y-auto sm:max-w-xl">
                <DialogHeader>
                    <DialogTitle>{entity.name}</DialogTitle>
                    <DialogDescription>
                        What Phoebe knows about them.
                    </DialogDescription>
                </DialogHeader>
                {markdown ? (
                    <Markdown>{markdown}</Markdown>
                ) : (
                    <p className="text-muted-foreground text-sm">
                        Phoebe is still writing this up.
                    </p>
                )}
            </DialogContent>
        </Dialog>
    );
}
